import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/home/close-video-mobile.png';
import _imports_1 from '@/assets/imgs/home/close-video-pc.png';
import _imports_2 from '@/assets/imgs/home/txt_logo.png';
import _imports_3 from '@/assets/imgs/home/down-hint.png';
import _imports_4 from '@/assets/imgs/home/app_qrcode.png';
import _imports_5 from '@/assets/imgs/home/miniprogram_qrcode.png';
import _imports_6 from '@/assets/imgs/home/search.png';
import _imports_7 from '@/assets/imgs/home/wechat.png';
import _imports_8 from '@/assets/imgs/home/weibo.png';
import _imports_9 from '@/assets/imgs/home/douyin.png';
import _imports_10 from '@/assets/imgs/home/xiaohongshu.png';
import _imports_11 from '@/assets/imgs/home/bilibili.png';

const _withScopeId = n => (_pushScopeId("data-v-4944c2c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "tvc-fullscreen-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  class: "tvc",
  autoplay: "",
  loop: "",
  controls: "",
  preload: "auto",
  "x5-video-orientation": "landscape",
  "webkit-playsinline": "true",
  playsinline: "true",
  "x-webkit-airplay": "true",
  "x5-video-player-type": "h5",
  "x5-video-player-fullscreen": "true",
  poster: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/home/newUser/bodypark-video-cover-img.png"
}, [/*#__PURE__*/_createElementVNode("source", {
  src: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/website/tvc-long.mp4",
  type: "video/mp4"
})], -1));

const _hoisted_3 = {
  class: "tvc-wrapper"
};
const _hoisted_4 = ["autoplay"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/website/tvc-short.mp4",
  type: "video/mp4"
}, null, -1));

const _hoisted_6 = [_hoisted_5];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tvc-mask"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_2
}, null, -1));

const _hoisted_9 = {
  class: "btn-wrapper"
};
const _hoisted_10 = {
  key: 0,
  src: _imports_3,
  class: "down-icon"
};
const _hoisted_11 = {
  class: "channel-wrapper"
};
const _hoisted_12 = {
  key: 2,
  class: "flex-blank"
};
const _hoisted_13 = {
  class: "slogan"
};
const _hoisted_14 = {
  class: "tag-list"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1));

const _hoisted_18 = {
  class: "qrcode-wrapper"
};
const _hoisted_19 = {
  class: "qrcode-item"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_4
}, null, -1));

const _hoisted_21 = {
  class: "scan-hint"
};
const _hoisted_22 = {
  class: "qrcode-item"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qrcode",
  src: _imports_5
}, null, -1));

const _hoisted_24 = {
  class: "scan-hint"
};
const _hoisted_25 = {
  class: "channel-list-wrapper"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "search-img",
  class: "channel-icon",
  src: _imports_6
}, null, -1));

const _hoisted_27 = {
  class: "channel-icon-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Modal = _resolveComponent("Modal");

  const _component_MobileModal = _resolveComponent("MobileModal");

  return _openBlock(), _createElementBlock("div", {
    class: "homecontainer",
    style: _normalizeStyle(_ctx.styleVar)
  }, [_ctx.showFullVideo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isMobile ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "close-icon",
    src: _imports_0,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeFullVideo && _ctx.closeFullVideo(...args))
  })) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "close-icon",
    src: _imports_1,
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.closeFullVideo && _ctx.closeFullVideo(...args))
  })), _hoisted_2])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("video", {
    class: "tvc",
    autoplay: _ctx.isNotXiaoMi,
    loop: "",
    muted: "",
    preload: "auto",
    "x5-video-orientation": "landscape",
    "webkit-playsinline": "true",
    playsinline: "true",
    "x-webkit-airplay": "true",
    "x5-video-player-type": "h5",
    "x5-video-player-fullscreen": "true",
    poster: "https://bpk-bucket-prod.oss-cn-beijing.aliyuncs.com/static/home/newUser/bodypark-video-cover-img.png"
  }, _hoisted_6, 8, _hoisted_4), _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    class: "btn try-btn",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.scrollToMPCode())
  }, _toDisplayString(_ctx.$t("m.haveATry")), 1), _createElementVNode("button", {
    class: "btn video-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.handleVideoRouter && _ctx.handleVideoRouter(...args))
  }, _toDisplayString(_ctx.$t("m.watchVideo")), 1)]), _ctx.isMobile ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true)], 512), [[_vShow, !_ctx.showFullVideo]]), _withDirectives(_createElementVNode("div", _hoisted_11, [!_ctx.isMobile ? (_openBlock(), _createBlock(_component_Modal, {
    key: 0,
    show: _ctx.show,
    qrCodeUrl: _ctx.qrCodeUrl,
    subHint: _ctx.subHint,
    onHideModal: _ctx.hideModal
  }, null, 8, ["show", "qrCodeUrl", "subHint", "onHideModal"])) : (_openBlock(), _createBlock(_component_MobileModal, {
    key: 1,
    show: _ctx.show,
    qrCodeUrl: _ctx.qrCodeUrl,
    subHint: _ctx.subHint,
    onHideModal: _ctx.hideModal
  }, null, 8, ["show", "qrCodeUrl", "subHint", "onHideModal"])), _ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, "“" + _toDisplayString(_ctx.$t("m.slogan")) + "”", 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("m.tagList.realPersonEdu")), 1), _hoisted_15, _createElementVNode("span", null, _toDisplayString(_ctx.$t("m.tagList.twoWay")), 1), _hoisted_16, _createElementVNode("span", null, _toDisplayString(_ctx.$t("m.tagList.AIGame")), 1), _hoisted_17, _createElementVNode("span", null, _toDisplayString(_ctx.$t("m.tagList.pelletRefining")), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("m.scanAppHint")), 1)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("m.scanHint")), 1)])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    id: "wechat-img",
    class: "channel-icon",
    src: _imports_7,
    onClick: _cache[4] || (_cache[4] = $event => _ctx.showQRCode('wechat'))
  }), _createElementVNode("img", {
    id: "weibo-img",
    class: "channel-icon",
    src: _imports_8,
    onClick: _cache[5] || (_cache[5] = $event => _ctx.gotoHLink('https://weibo.com/u/7639183108'))
  }), _createElementVNode("img", {
    id: "douyin-img",
    class: "channel-icon",
    src: _imports_9,
    onClick: _cache[6] || (_cache[6] = $event => _ctx.showQRCode('douyin'))
  }), _createElementVNode("img", {
    id: "xiaohongshu-img",
    class: "channel-icon",
    src: _imports_10,
    onClick: _cache[7] || (_cache[7] = $event => _ctx.gotoHLink('https://www.xiaohongshu.com/user/profile/60f63dfc0000000001016684'))
  }), _createElementVNode("img", {
    id: "bilibili-img",
    class: "channel-icon",
    src: _imports_11,
    onClick: _cache[8] || (_cache[8] = $event => _ctx.gotoHLink('https://space.bilibili.com/1957699038'))
  })])])], 512), [[_vShow, !_ctx.showFullVideo]])], 4);
}